export enum Section {
  BROWSER = 'BROWSER',
  WORKSPACE = 'WORKSPACE',
  REGISTRY_SETTINGS_BOX_SCHEMAS = 'REGISTRY_SETTINGS_BOX_SCHEMAS',
  REGISTRY_SETTINGS_CONTAINER_SCHEMAS = 'REGISTRY_SETTINGS_CONTAINER_SCHEMAS',
  REGISTRY_SETTINGS_GENERAL = 'REGISTRY_SETTINGS_GENERAL',
  REGISTRY_SETTINGS_LABEL_PRINTING = 'REGISTRY_SETTINGS_LABEL_PRINTING',
  REGISTRY_SETTINGS_LOCATION_SCHEMAS = 'REGISTRY_SETTINGS_LOCATION_SCHEMAS',
  REGISTRY_SETTINGS_PLATE_SCHEMAS = 'REGISTRY_SETTINGS_PLATE_SCHEMAS',
  REGISTRY_SETTINGS_SCHEMAS = 'REGISTRY_SETTINGS_SCHEMAS',
  REGISTRY_SETTINGS_SELECTORS = 'REGISTRY_SETTINGS_SELECTORS',
  SCHEMA_INTERFACE_SETTINGS = 'SCHEMA_INTERFACE_SETTINGS',
  TAG_SCHEMA_SETTINGS = 'TAG_SCHEMA_SETTINGS',
  SELECTOR_SETTINGS = 'SELECTOR_SETTINGS',
  NOTEBOOK_SETTINGS_TEMPLATE_COLLECTIONS = 'NOTEBOOK_SETTINGS_TEMPLATE_COLLECTIONS',
  NOTEBOOK_SETTINGS_TEMPLATE_COLLECTION = 'NOTEBOOK_SETTINGS_TEMPLATE_COLLECTION',
  NOTEBOOK_SETTINGS_TEMPLATE = 'NOTEBOOK_SETTINGS_TEMPLATE',
  REQUEST_SCHEMAS = 'REQUEST_SCHEMAS',
  REQUEST_TASK_SCHEMAS = 'REQUEST_TASK_SCHEMAS',
  ASSAY_RESULT_SCHEMAS = 'ASSAY_RESULT_SCHEMAS',
  ASSAY_RUN_SCHEMAS = 'ASSAY_RUN_SCHEMAS',
  CONNECTION_SCHEMAS = 'CONNECTION_SCHEMAS',
  INSTRUMENT_GATEWAYS = 'INSTRUMENT_GATEWAYS',
  PARAMETER_LIBRARY = 'PARAMETER_LIBRARY',
  PROCESS_SCHEMAS = 'PROCESS_SCHEMAS',
  DATA_POLICIES = 'DATA_POLICIES',
  SCHEMA_POLICIES = 'SCHEMA_POLICIES',
  EVENT_SUBSCRIPTIONS = 'EVENT_SUBSCRIPTIONS',
  BENCHLING_APPS_SETTINGS = 'BENCHLING_APPS_SETTINGS',
  BENCHLING_APP_CANVAS_BUILDER = 'BENCHLING_APP_CANVAS_BUILDER',
  CONFIG_MIGRATION = 'CONFIG_MIGRATION',
  TENANT_COMPARISON = 'TENANT_COMPARISON',
  MONOMERS = 'MONOMERS',
  AA_MONOMERS = 'AA_MONOMERS',
  TENANT_LEVEL_LABEL_PRINTING_SETTINGS = 'TENANT_LEVEL_LABEL_PRINTING_SETTINGS',
  TENANT_LEVEL_INVENTORY_SETTINGS = 'TENANT_LEVEL_INVENTORY_SETTINGS',
  TEST_DEFINITIONS = 'TEST_DEFINITIONS',
  REVIEW_LIFECYCLES = 'REVIEW_LIFECYCLES',
  SAMPLE_TYPES = 'SAMPLE_TYPES',
  SALT_LIBRARY = 'SALT_LIBRARY',
  SOLVENT_LIBRARY = 'SOLVENT_LIBRARY',
  STUDY_SCHEMAS = 'STUDY_SCHEMAS',
  UNIT_DICTIONARY = 'UNIT_DICTIONARY',
  ATTACHMENT_PREVIEW = 'ATTACHMENT_PREVIEW',
  TEMPLATE_COLLECTIONS_SEARCH = 'TEMPLATE_COLLECTIONS_SEARCH',
}
export const STANDARD_SECTIONS = [Section.BROWSER, Section.WORKSPACE];

export const SETTINGS_SECTIONS = [
  Section.REGISTRY_SETTINGS_BOX_SCHEMAS,
  Section.REGISTRY_SETTINGS_CONTAINER_SCHEMAS,
  Section.REGISTRY_SETTINGS_GENERAL,
  Section.REGISTRY_SETTINGS_LABEL_PRINTING,
  Section.REGISTRY_SETTINGS_LOCATION_SCHEMAS,
  Section.REGISTRY_SETTINGS_PLATE_SCHEMAS,
  Section.REGISTRY_SETTINGS_SCHEMAS,
  Section.REGISTRY_SETTINGS_SELECTORS,
  Section.SCHEMA_INTERFACE_SETTINGS,
  Section.TAG_SCHEMA_SETTINGS,
  Section.NOTEBOOK_SETTINGS_TEMPLATE,
  Section.NOTEBOOK_SETTINGS_TEMPLATE_COLLECTION,
  Section.NOTEBOOK_SETTINGS_TEMPLATE_COLLECTIONS,
  Section.REQUEST_SCHEMAS,
  Section.REQUEST_TASK_SCHEMAS,
  Section.ASSAY_RESULT_SCHEMAS,
  Section.ASSAY_RUN_SCHEMAS,
  Section.CONNECTION_SCHEMAS,
  Section.INSTRUMENT_GATEWAYS,
  Section.PARAMETER_LIBRARY,
  Section.PROCESS_SCHEMAS,
  Section.DATA_POLICIES,
  Section.SCHEMA_POLICIES,
  Section.BENCHLING_APPS_SETTINGS,
  Section.EVENT_SUBSCRIPTIONS,
  Section.BENCHLING_APP_CANVAS_BUILDER,
  Section.CONFIG_MIGRATION,
  Section.TENANT_COMPARISON,
  Section.MONOMERS,
  Section.AA_MONOMERS,
  Section.TENANT_LEVEL_LABEL_PRINTING_SETTINGS,
  Section.TENANT_LEVEL_INVENTORY_SETTINGS,
  Section.TEST_DEFINITIONS,
  Section.REVIEW_LIFECYCLES,
  Section.SAMPLE_TYPES,
  Section.STUDY_SCHEMAS,
  Section.UNIT_DICTIONARY,
  Section.ATTACHMENT_PREVIEW,
  Section.SALT_LIBRARY,
  Section.SOLVENT_LIBRARY,
] as const;

export type SettingsSection = (typeof SETTINGS_SECTIONS)[number];

export const REGISTRY_SCHEMAS_SECTIONS = [Section.REGISTRY_SETTINGS_SCHEMAS, Section.TAG_SCHEMA_SETTINGS];
export const REGISTRY_SELECTORS_SECTIONS = [Section.REGISTRY_SETTINGS_SELECTORS, Section.SELECTOR_SETTINGS];
